import { useEffect, useState } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import CtaBand from "../components/CtaBand";
import Icon from "../components/Icons";
import Seo from "../seo/Seo";
import styles from "./BlogPostPage.module.css";
import { fetchPost } from "../data/firestore";
import { isFirebaseConfigured } from "../firebase";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

function Block({ block }) {
  switch (block.type) {
    case "h2":
      return <h2 className={styles.h2}>{block.text}</h2>;
    case "h3":
      return <h3 className={styles.h3}>{block.text}</h3>;
    case "ul":
      return (
        <ul className={styles.ul}>
          {block.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      );
    case "quote":
      return <blockquote className={styles.quote}>{block.text}</blockquote>;
    case "p":
    default:
      return <p className={styles.p}>{block.text}</p>;
  }
}

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined); // undefined = loading, null = not found

  useEffect(() => {
    let cancelled = false;
    if (!isFirebaseConfigured) {
      setPost(null);
      return;
    }
    fetchPost(slug).then((p) => !cancelled && setPost(p));
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (post === null) return <Navigate to="/404" replace />;
  if (post === undefined) {
    return (
      <div className={styles.loadingPage}>
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <>
      <Seo
        title={`${post.title} | Dr. Aakash Sharma`}
        description={post.excerpt}
        pathname={`/blog/${slug}`}
        label={post.title}
      />

      <PageHeader
        eyebrow={`${formatDate(post.date)}${
          post.readingMinutes ? ` · ${post.readingMinutes} min read` : ""
        }`}
        title={post.title}
        lead={post.excerpt}
      />

      <article className={`u-section ${styles.section}`}>
        <div className={`u-shell ${styles.body}`}>
          {post.body?.map((block, i) => (
            <Block key={i} block={block} />
          ))}

          {post.tags?.length > 0 && (
            <ul className={styles.tags}>
              {post.tags.map((tag) => (
                <li key={tag}>{tag}</li>
              ))}
            </ul>
          )}

          <Link to="/blog" className={styles.back}>
            <Icon name="arrow" size={16} className={styles.backIcon} />
            All articles
          </Link>
        </div>
      </article>

      <CtaBand />
    </>
  );
}
